import { render } from "./pc_destination_update.vue?vue&type=template&id=35f9d5cb&scoped=true"
import script from "./pc_destination_update.vue?vue&type=script&lang=js"
export * from "./pc_destination_update.vue?vue&type=script&lang=js"

import "./pc_destination_update.vue?vue&type=style&index=0&id=35f9d5cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f9d5cb"]])

export default __exports__